var render = function render(_c, _vm) {
  return _c(
    "span",
    {
      class: {
        "text-danger": _vm.props.stock <= 0,
        "text-warning": _vm.props.stock < 5 && _vm.props.stock > 0,
      },
    },
    [_vm._v("\n  " + _vm._s(_vm.props.stock) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }